var POSTrequest = function(url, data, el, flag) {

	var parent = el.parentElement;
	var user   = parent.dataset.userType || "User";
	var xhr = new XMLHttpRequest();

	el.disabled = true;

	request();

	/*  FUNCTIONS  */

	function request() {
		xhr.open("POST", url, true);
		xhr.send(data);
		xhr.onreadystatechange = function() {

			if (this.readyState === 4 && this.status === 200) {
				//console.log(this.responseTex);
				toChange();
			} else {
				if(this.status >= 400) {
					console.log("Error " + this.status);
				}
			}

			setTimeout(() => {
				el.disabled = false;
			}, 100);
		};
	}

	function toChange() {
		var action    = {
			0: "Enable",
			1: "Disable",
			2: "Reenable"
		};

		switch(flag) {
			case "enable":
				// "Enable User"
				el.form.action = "/admin/users/enable";
				parent.classList.remove("btnDisable");
				parent.classList.add("btnEnable");
				if(user.toLowerCase() === "dealer") parent.dataset.action = 2;
				else parent.dataset.action = 0;
				break;

			case "disable":
				// "Disable User";
				el.form.action = "/admin/users/disable";
				parent.classList.remove("btnEnable");
				parent.classList.add("btnDisable");
				parent.dataset.action = 1;
				break;
		}

		el.value = action[parent.dataset.action] + ' ' + user;
	}
};

var AdminPopup = function(popupElem, resetFn, disabledFn, reasonFn, url, form, regEl, reqMod) {
	var disabledClass = "disabled";
	var openClass     = "open";
	var closeClass    = "close";
	var button        = "btnDisable";


	function listener(popup, reset, disabled, reason, reqUrl, reqForm, requestEl, reqModif) {
		if(popup instanceof HTMLElement) {
			let dis = popup.querySelector(".btnDisable");
			let textarea = popup.querySelector("textarea");

			if(dis && textarea && textarea.value === "") dis.classList.add(disabledClass);
			
			popup.addEventListener("click", function(event) {
				event = event || window.event;
				var target = event.target;

				close(target, popup, reset);
				disbd(target, popup, disabled, reason, reqUrl, reqForm, requestEl, reqModif);
			});
		}
	}

	function close(btn, popup, reset) {
		if(btn instanceof HTMLElement) {

			if(btn.classList.contains(closeClass)) popup.classList.remove(openClass);

			else if(btn.type === "reset") {
				if(reset && typeof reset === "function") reset(popup);

				popup.classList.remove(openClass);
			}
		}
	}

	function disbd(btn, popup, disFn, resFn, reqUrl, reqForm, requestEl, reqModif) {
		var textarea = popup.querySelector("textarea");

		if(btn instanceof HTMLElement && btn.classList.contains(button) && !btn.classList.contains(disabledClass)) {
			popup.classList.remove(openClass);

			if(resFn && typeof resFn === "function" && textarea) resFn(popup, textarea.value);
			if(disFn && typeof disFn === "function") disFn(reqUrl, new FormData(reqForm), requestEl, reqModif);
		}
	}

	function textArea(popup) {
		var dis = popup.querySelector(".btnDisable");
		var textarea = popup.querySelector("textarea");

		if(textarea) textarea.addEventListener("input", function() {
			if(this.value !== "") dis.classList.remove(disabledClass);
			else dis.classList.add(disabledClass);
		});
	}

	popupElem.classList.add(openClass);
	textArea(popupElem);
	listener(popupElem, resetFn, disabledFn, reasonFn, url, form, regEl, reqMod);
};

// send Ajax POST request
(function() {

	document.addEventListener("DOMContentLoaded", function() {

		var container = document.getElementById("listings_ds");

		if(container) {
			var inputs = container.querySelectorAll("*[type=submit]");

			for( var i = 0; i < inputs.length; i++ ) {
				var btn = inputs[i];

				if(btn.parentElement.classList.contains("btnDisable") || btn.parentElement.classList.contains("btnEnable")) {
					
					btn.addEventListener("click", function(event) {
						event = event || window.event;
						event.preventDefault();

						var data = new FormData(this.form);
						var url  = this.form.action;

						if(this.parentElement.classList.contains("btnDisable")) {
							if(this.parentElement.classList.contains("popupOpen")) {
								let popup  = this.parentElement.nextElementSibling;

								if(popup !== null && popup.classList.contains("dealer-section__popup")) {
									AdminPopup(popup, reset, disabled, reason, "/admin/users/disable", this.form, this, "enable");
								}

							}
						}
						if(this.parentElement.classList.contains("btnEnable")) {
							POSTrequest("/admin/users/enable", data, this, "disable");
							reset(this.parentElement);
						}
					});
				}
			}
		}


		function reset(elem) {
			let reason = elem.parentElement.parentElement.nextElementSibling;

			if(reason && reason.classList.contains("dealer-approved-reason"))
			reason.textContent = "";
		}

		function disabled(reqUrl, reqData, requestEl, reqModif) {
			POSTrequest(reqUrl, reqData, requestEl, reqModif);
		}

		function reason(elem, text) {
			let reason = elem.parentElement.parentElement.nextElementSibling;

			if(reason && reason.classList.contains("dealer-approved-reason"))
			reason.textContent = text;
		}

	});
})();